import create, { SetState, StateCreator, StoreApi } from "zustand";

interface IPopulationInsightStore {
  clearStore: () => void;
  patientIds: any;
  patientIdsHandler: (x: any) => void;
  comingFromPopulationInst: boolean;
  memberPageNavigationHandler: (x: boolean) => void;
  comingFromMembers: boolean;
  handleComingFromMembersFlag: (x: boolean) => void;
  filtersData: any;
  setFiltersData: (x: any) => void;
  activeSideCardIndex: number | undefined;
  setActiveSideCardIndex: (x: number | undefined) => void;
  rangeStartDate: any;
  setRangeStartDate: (x: any) => void;
  rangeEndDate: any;
  setRangeEndDate: (x: any) => void;
  selectedFilterOptions: any;
  setSelectedFilterOptions: (x: any) => void;
  stateInfo: any;
  setStateInfo: (x: any) => void;
  isReasonsModalVisible: boolean;
  handleReasonsModalVisibility: (x: boolean) => void;
  reasonModalTitle:any;
  setReasonModalTitle: (x: any) => void;
}

let store: StateCreator<IPopulationInsightStore, [], [], IPopulationInsightStore> | StoreApi<IPopulationInsightStore> = (set: SetState<IPopulationInsightStore>) => ({
  patientIds: [],
  patientIdsHandler: (x) => {
    set((state) => ({ patientIds: x }));
  },
  comingFromPopulationInst: false,
  memberPageNavigationHandler: (x) => {
    set(() => ({ comingFromPopulationInst: x }));
  },
  comingFromMembers: false,
  handleComingFromMembersFlag: (x) => {
    set(() => ({ comingFromMembers: x }));
  },
  filtersData: [],
  setFiltersData: (x) => {
    set(() => ({ filtersData: x }));
  },
  activeSideCardIndex: undefined,
  setActiveSideCardIndex: (x) => {
    set(() => ({ activeSideCardIndex: x }));
  },
  rangeStartDate: undefined,
  setRangeStartDate: (x) => {
    set(() => ({ rangeStartDate: x }));
  },
  rangeEndDate: undefined,
  setRangeEndDate: (x) => {
    set(() => ({ rangeEndDate: x }));
  },
  selectedFilterOptions: [],
  setSelectedFilterOptions: (x) => {
    set(() => ({ selectedFilterOptions: x }));
  },
  stateInfo: {
    isLoading: true,
  },
  setStateInfo: (x) => {
    set(() => ({ stateInfo: x }));
  },
  isReasonsModalVisible: false,
  handleReasonsModalVisibility: (x) => {
    set(() => ({ isReasonsModalVisible: x }));
  },
  reasonModalTitle: undefined,
  setReasonModalTitle: (x) => {
    set(() => ({ reasonModalTitle: x }));
  },
  clearStore: () => {
    set(() => ({ patientIds: [] }));
    set(() => ({ comingFromPopulationInst: false }));
    set(() => ({ comingFromMembers: false }));
    set(() => ({ filtersData: [] }));
    set(() => ({ activeSideCardIndex: undefined }));
    set(() => ({ rangeStartDate: undefined }));
    set(() => ({ rangeEndDate: undefined }));
    set(() => ({ selectedFilterOptions: [] }));
    set(() => ({
      stateInfo: {
        isLoading: true,
      },
    }));
    set(() => ({ isReasonsModalVisible: false }));
    set(() => ({ reasonModalTitle: undefined }));
  },
});

export const usePopulationInsightStore = create(store);
